import { Grid, MenuItem, TextField } from '@mui/material';
import { IAssetLocation } from '../../../../../../Interfaces/Asset/IAssetLocation';
import { IBankAccountAsset } from '../../../../../../Interfaces/Asset/IBankAccountAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type BankAccountAssetViewProps = ITestamentAssetsViewProps<IBankAccountAsset>;

export function BankAccountAssetView({
  asset,
  setAsset,
}: BankAccountAssetViewProps) {
  const isForeign = asset.data.assetLocation === IAssetLocation.Foreign;
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          label={
            isForeign ? 'Geschätzter Kontostand in Euro' : 'Kontostand in Euro'
          }
          size='small'
          value={asset.data.balance || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            console.log('Changing balance to', event.target.value);
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                balance: Number(event.target.value),
              },
            });
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          label='Lage des Kontos'
          select
          size='small'
          value={asset.data.assetLocation || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                assetLocation: event.target.value as IAssetLocation,
              },
            })
          }
          fullWidth
        >
          <MenuItem value={IAssetLocation.Domestic}>Inländisch</MenuItem>
          <MenuItem value={IAssetLocation.Foreign}>Ausländisch</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField
          label='Sonstige Informationen'
          rows={2}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
